import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router'
import { of } from 'rxjs'
import { AuthService, MsalUserGuardService } from '@appShared/services'
import { SITE_DIRECTORY_ROUTES } from '@appShared/site-directory.routes'

export const PublicOnlyGuardService: CanActivateFn = (
   route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot
) => {

   //TODO: REMOVE
   //return of(true)

   const authService = inject(AuthService)
   const redirectUrl = authService.redirectUrl() || `/${SITE_DIRECTORY_ROUTES.customerService.uri}`
   return inject(MsalUserGuardService).msalNonAuthenticated(redirectUrl)
}
//export class PublicOnlyGuardService {
//   private _appSignals = inject(AppSignals)
//   private _router = inject(Router)

//   canActivate(): Observable<boolean> {

//      const currentUser = this._appSignals.currentUser()

//      // if already logged as rep/admin - then send to "content" section
//      if (currentUser?.isAdmin || currentUser?.isRep) {
//         this._router.navigate([`${SITE_DIRECTORY_ROUTES.customerService.uri}`])
//         return of(false)
//      }

//      return of(true)
//   }
//}
